// SPDX-License-Identifier: LicenseRef-VicZhuProprietary
// SPDX-FileCopyrightText: 2026 Vic Zhu <viczhu2014@gmail.com>

/**
 * The clinic-verification request the ops Go server accepts
 * (POST /api/v1/shop/clinic-verification — ops/services/internal/shop/model.go
 * SubmitVerificationRequest). Ported from the marketing site's
 * sites/src/lib/clinic-verification-helpers.ts so the portal and the site
 * submit the SAME vocabulary — the queue Alex reviews cannot tell them apart.
 */

export interface VerificationRequest {
  professionalRole: string
  professionalTitle: string
  hospitalName: string
  hospitalType: string
  numberOfVets: number
  businessAddress: {
    line1: string
    line2: string
    city: string
    state: string
    postalCode: string
    country: string
  }
  phoneNumber: string
}

/** The practice-type choices the form offers (same set as the site's form). */
export const PRACTICE_TYPES = ['general', 'emergency', 'specialty', 'mobile', 'other'] as const
export type PracticeType = (typeof PRACTICE_TYPES)[number]

export function inferProfessionalRole(title: string): string {
  const normalized = title.trim().toLowerCase()
  if (normalized.includes('tech')) return 'vet_tech'
  if (normalized.includes('manager')) return 'clinic_manager'
  if (normalized.includes('owner')) return 'practice_owner'
  return 'veterinarian'
}

export function mapPracticeType(value: string): string {
  switch (value) {
    case 'emergency':
    case 'specialty':
      return 'specialty'
    case 'mobile':
      return 'mixed'
    default:
      return 'small_animal'
  }
}

/**
 * The Go side's own refusal for a second submission
 * ("verification already submitted (status: pending)"). Treated as DONE by
 * the prompt — the account is already in the queue, which is the outcome
 * the prompt exists to produce.
 */
export function isAlreadySubmittedError(message: string): boolean {
  return /already submitted/i.test(message)
}
